import store, {history} from "@/redux/store";
import { push } from 'react-router-redux';
import React, { useState } from "react";
import { useParams,Link, useNavigate, useLocation } from "react-router-dom";
//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { Overview } from "@/views/team/Overview";
import { loadUsers } from '@/reducers/User'
import { show, MODAL_TYPE_TENANT_CHANGED, hide } from '@/reducers/Modal'
import MenuView from "@/views/Menu";



import {
  CalendarIcon,
  ChartPieIcon,
  DocumentDuplicateIcon,
  DocumentIcon,
  FolderIcon,
  HomeIcon,
  UsersIcon,
} from '@heroicons/react/24/outline'

class MenuController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
    
    
this.teamMenu = [
  { name: 'Intern Team', href: '#', icon: UsersIcon, current: false, to: "/team/" },
  { name: 'Extern Team', href: '#', icon: UsersIcon, current: false, to: "/team/" },
  { name: 'Klanten', href: '#', icon: UsersIcon, current: false, to: "/customers/" },
  { name: 'Calendar', href: '#', icon: CalendarIcon, count: '20+', current: false, to: "/files/" },
  { name: 'Documents', href: '#', icon: DocumentDuplicateIcon, current: false, to: "/files/" },
  { name: 'Reports', href: '#', icon: ChartPieIcon, current: false, to: "/files/" },
]    
    //this.checkCurrentMenuLocation()
  }
  
  checkCurrentMenuLocation =() =>{
      const {location} = this.props;
    const { pathname } = location;
    const splitLocation = pathname.split("/");
    const activeMenuItem = splitLocation[1];
      
      for(let i=0;i < this.teamMenu.length; i++) {
          this.teamMenu[i].current = false;
          if(pathname.indexOf( this.teamMenu[i]["to"] ) === 0) {
              this.teamMenu[i].current = true;
          }
      }
  }

  


  render() {
      return (
          <>
          </>
      );
      
  }
}
const MenuControllerInit = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    
  return (
    <MenuController
      {...props} location={location} navigate={navigate}
    />
  );
};

function mapStateToProps(state) {
    const{ModalReducer, AuthReducer} = state;
  return {
        ModalReducer,AuthReducer
  };
}

export default connect(mapStateToProps)(MenuControllerInit);  